<script setup lang="ts">
interface Props {
  totalAmount?: string
}

withDefaults(defineProps<Props>(), {
  totalAmount: '65412.5 s',
})

const currentYear = new Date().getFullYear()
</script>

<template>
  <footer class="border-t border-gray-200 py-4 px-6 h-[73px] bg-white">
    <div
      class="flex lg:flex-row flex-col lg:justify-between lg:items-center justify-start items-start h-full"
    >
      <div class="text-sm text-gray-600">
        {{ $t("footer_copyright", { year: currentYear }) }}
      </div>
      <div class="flex items-center gap-4">
        <ElLink
          href="https://t.me/marketassist_support"
          size="small"
          target="_blank"
        >
          <i class="icon-telegram text-2xl" />
        </ElLink>
      </div>
    </div>
  </footer>
</template>
